export const TITLE_COLOR = '#000000';
export const DEFAULT_TEXT_COLOR = '#000000';
